import { TExportSelectedData } from './export-data';
import { EExportData } from './export-data-enum';

export const word_data: TExportSelectedData[] = [
  { name: 'ID', id: EExportData.ID },
  { name: 'Title', id: EExportData.TITLE },
  { name: 'Description', id: EExportData.DESCRIPTION },
  { name: 'Priority', id: EExportData.PRIORITY },
  { name: 'Status', id: EExportData.STATUS },
  { name: 'Created Date', id: EExportData.CREATED_DATE },
  { name: 'Edit Date', id: EExportData.EDIT_DATE },
  { name: 'Comments', id: EExportData.COMMENTS },
  { name: 'Export Date', id: EExportData.EXPORT_DATE },
  { name: 'Tags', id: EExportData.TAGS },
  { name: 'Custom Fields', id: EExportData.CUSTOM_FIELDS },
  { name: 'Images', id: EExportData.IMAGES },
  { name: 'Files', id: EExportData.FILES },
  { name: 'Flags', id: EExportData.SHOW_FLAGS },
];
